import initialStates from "./initialStates";

const reducer = (state = initialStates, action) => {
    switch (action.type) {
        // case is empty now, i will add features when i will get enough time.
        default:
            return state;
    }
};

export default reducer;
